







































import {Component, Vue, Watch} from "vue-property-decorator";
import Goback from "@/views/frame/GoBack.vue";
import store from '@/vuex'


@Component({
  components: {

    Goback
  },
})
export default class Header extends Vue {
  localPath: string = "home";
  isShowAppliantModal: boolean = false;

  getLocalPath() {
    return store.state.localPath;
  }
  boxShadowStyle:string='undefined'
  applyForTest() {

  }
  isActive(path){
    // console.log(this.getLocalPath())
    console.log(this.$route.path)
    // console.log(this.$route.path.startsWith(path))
    return this.$route.path.startsWith("/"+path)
  }
  scrollTop:number=0;
  public isTop:boolean=true;
  mounted() {
    // store.commit('SET_LOCAL_PATH', this.$route.path);

    this.init()
  }
  init(){
    let that=this;
    $(window).scroll(function () {
      // that.scrollTop=$(window).scrollTop();
      if ($(window).scrollTop() > 5) {
        $('.web-header').css({boxShadow: '0 1px 12px 0 rgba(136, 136, 136, 0.9)'})
        // that.isTop=false;
        // that.boxShadowStyle='0 4px 8px 0 rgba(0, 0, 0, 0.20)'
      }else{
        $('.web-header').css({boxShadow: '0 0px 0px 0 rgba(136, 136, 136, 0.9)'})
        // $('.web-header').css({boxShadow: 'undefined !important'})
        // that.isTop=true;
        // that.boxShadowStyle='undefined'

      }
    })
  }
  jump(path) {

    store.commit('SET_LOCAL_PATH', path);
    this.$router.push(`/${path}`);

  }

  openAppliantModal() {
    this.isShowAppliantModal = true;
  }

  closeAppliantModal() {
    this.isShowAppliantModal = false
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/frame/Header.vue